<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Servicios`,
          link: 'Servicios',
        },
        {
          text: service.id ? service.name : 'Nuevo servicio',
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <!-- NOMBRE -->
            <div class="form-group">
              <label>Nombre</label>
              <input
                type="text"
                v-model="service.name"
                :class="`form-control ${errors.name ? 'is-invalid' : ''}`"
              />
            </div>

            <!-- NOMBRE CORTO -->
            <div class="form-group">
              <label>Cantidad</label>
              <input
                type="text"
                v-model="service.amount"
                :class="`form-control ${errors.amount ? 'is-invalid' : ''}`"
              />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-12 text-right">
              <button
                :disabled="saving"
                class="btn main-green-bg"
                @click="saveService"
              >
                <span v-if="saving">Espere</span>
                <span v-else>
                  <i class="fa fa-save"></i>
                  Guardar cambios
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSelectBtn from "../components/ImageSelectBtn";
import Breadcrumbs from "../components/Breadcrumbs";
import { CompanyService } from "../../services/CompanyService";
import Loader from "../components/Loader";
import PhotoUploader from "../../commons/PhotoUploader";

export default {
  name: "CompanyDetail",
  components: {
    ImageSelectBtn,
    Breadcrumbs,
    Loader,
  },
  data: function () {
    return {
      service: {
        id: "",
        name: "",
        amount: "",
      },
      saving: false,
      loading: false,
      companyService: new CompanyService(),
      errors: {
        name: false,
        amount: false,
      },
    };
  },
  methods: {
    validateFields() {
      if (this.service.name.length < 3) {
        this.$helpers.toast(
          "Nombre debe ser mayor que 3 caracteres",
          "warning"
        );
        this.errors.name = true;
        return false;
      }
      this.errors.name = false;

      if (this.service.amount.length < 0) {
        this.$helpers.toast("No puede colocar la cantidad en 0", "warning");
        this.errors.amount = true;
        return false;
      }
      this.errors.amount = false;

      return true;
    },

    cleanAllFields: function () {
      this.company = {
        id: "",
        name: "",
        amount: "",
      };
    },

    saveService: async function () {
      if (this.$route.params.service_id != 0) {
        this.updateCompanyMethod();
        return;
      }
      if (!this.validateFields()) return false;

      this.saving = true;
      try {
        let res = null;

        var data = {
          Name: this.service.name,
          Amount: parseInt(this.service.amount),
        };

        res = await this.companyService.addService(data);

        if (res.ok) {
          this.$helpers.message("Bien", "Datos guardados.");
          this.$router.push("/services");
        } else {
          this.$helpers.message("Oops", res.message, "error");
        }
      } catch (error) {
        this.$helpers.message("Oops", "Algo salio mal", "error");
        console.log(error);
      }
      this.saving = false;
    },

    async updateCompanyMethod() {
      try {
        let res = null;
        var data = {
          Id: this.service.id,
          Name: this.service.name,
          Amount: parseInt(this.service.amount),
        };
        res = await this.companyService.updateService(data);
        if (res.ok) {
          this.$helpers.message("Bien", "Datos guardados.");
          this.$router.push("/services");
        } else {
          this.$helpers.message("Oops", res.message, "error");
        }
        this.loading = true;
        this.loading = false;
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async getServiceByIdLocal() {
      try {
        this.loading = true;
        const res = await this.companyService.getServiceByID(
          this.$route.params.service_id
        );
        this.service.id = res.data.Id;
        this.service.name = res.data.Name;
        this.service.amount = res.data.Amount;
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
        this.loading = false;
      }
    },
  },
  watch: {
    "company.photo": function (value) {
      if (value) {
        this.photoPreview = value;
      }
    },
  },
  mounted: async function () {
    if (this.$route.params.service_id != 0) {
      this.getServiceByIdLocal();
    }
  },
};
</script>
<style scoped>
.photo-preview {
  height: 140px;
}
.list-group {
  max-height: 200px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
